module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA9.d5897229.jpg";